module.exports = __webpack_public_path__ + "img/armchairs.01aa93c7.jpg";